module.exports = __webpack_public_path__ + "img/Logo-Amplifiers-Account.623a0148.svg";